import { graphql } from "@/gql";

export const importRelocationsMutation = graphql(`
  mutation ImportRelocationsMutation($input: ImportRelocationsInput!) {
    importRelocations(input: $input)
  }
`);
